export const TASK_NOT_STARTED_PERCENT = 0
export const TASK_COMPLETE_PERCENT = 100




// WEBPACK FOOTER //
// ./src/constants/taskConstants.js